<template>
  <v-radio-group id="radio-lang-select" class="mt-0" v-model="locale" hide-details row>
    <v-radio
      on-icon="done"
      v-for="loc in locales"
      :key="loc"
      :label="$t(`i18n.${loc}`)"
      :value="loc"
      :id="`locales-${loc}`"
    />
  </v-radio-group>
</template>

<script>
export default {
  computed: {
    locale: {
      get () {
        return this.$store.state.locale.locale
      },
      set (val) {
        this.$store.commit('locale/SET_LOCALE', val)
      }
    },
    locales () {
      return this.$store.state.locale.locales
    }
  },
  methods: {
    setLocale (locale) {
      this.$store.commit('locale/SET_LOCALE', locale)
    }
  }
}
</script>

<style lang="scss">
#radio-lang-select{
  label.v-label {
    font-size: .75rem;
  }

  .v-radio {
    margin-right: 5px;
    }

  .v-input--selection-controls__input{
    margin-right: 0px;

    .v-icon{
      font-size: 17px;
    }
    &:has(.mdi-radiobox-blank) {
        opacity: 0;
    }
  }
}

</style>
